import React from "react";
import PropTypes from "prop-types";
import RaisedButton from "@mui/material/Button";
import { withStyles } from "@mui/styles";
import { styles } from "./styles";

class WrongAccount extends React.Component {
  render() {
    const { classes, shop, current_email } = this.props;
    const shop_name = shop ? shop.name : null;
    const email_hint = shop ? shop.email_hint : null;
    const text = shop_name
      ? "Sign in with the " + shop_name + " account to approve it."
      : "Sign in with the shop account to approve it.";

    return (
      <div className={"box box-default " + classes.card}>
        <div className={"box-body text-center " + classes.wrong_account_body}>
          <div className={classes.wrong_account_avatar}>
            <span className={"material-icons " + classes.wrong_account_icon}>
              person
            </span>
          </div>
          <h2 className={classes.wrong_account_title}>
            You don't have access to approve this cashbox request.
          </h2>
          <p className={classes.wrong_account_text}>{text}</p>
          {current_email && (
            <p className={classes.wrong_account_current}>
              Signed in as{" "}
              <span className={classes.wrong_account_current_email}>
                {current_email}
              </span>
            </p>
          )}
          <div className={classes.wrong_account_details}>
            {email_hint && (
              <div className={classes.wrong_account_detail}>
                <div className={classes.wrong_account_detail_label}>
                  Shop account:
                </div>
                <div className={classes.wrong_account_detail_value}>
                  {email_hint}
                </div>
              </div>
            )}
            <div className={classes.wrong_account_detail}>
              <div className={classes.wrong_account_detail_label}>
                {email_hint ? "Or a team member account:" : "Team member account:"}
              </div>
              <div className={classes.wrong_account_detail_value}>
                Any account associated with the shop profile
              </div>
            </div>
          </div>
          <RaisedButton
            variant="contained"
            fullWidth
            size="large"
            className={classes.wrong_account_button}
            onClick={this.props.handleSignInWithAnotherAccount}
          >
            Sign in with a different account
          </RaisedButton>
        </div>
      </div>
    );
  }
}

WrongAccount.propTypes = {
  classes: PropTypes.object.isRequired,
  shop: PropTypes.object,
  current_email: PropTypes.string,
  handleSignInWithAnotherAccount: PropTypes.func.isRequired
};

export default withStyles(styles)(WrongAccount);
